import React from 'react';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import statuses from './panel-statuses';
import './PanelStatus.scss';

type Props = {
    seleniumid: string;
    status: keyof typeof statuses;
    l: l;
};

function PanelStatus({ seleniumid, status, l }: Props) {
    const statusData = statuses[status];

    if (!statusData) {
        return null;
    }

    // @ts-ignore
    const { className, codeName, icon: { iconType, ...iconParameters } = {} } = statusData;
    const Icon = iconType ? SvgIcon[iconType] : null;

    return (
        <div className={className} data-seleniumid={`${seleniumid}-status`}>
            {l(`SIMPLE_PANEL.${codeName}`)}
            {Icon && <Icon {...iconParameters} />}
        </div>
    );
}

export default withCodes2(ID.SIMPLE_PANEL)(PanelStatus);
